import React from 'react';
import { formatBytes } from '../../utilities/format';

interface LargeTextWarningProps {
  textBytes: number;
  downloadUrl?: string;
  onShow: () => void;
}

export default function LargeTextWarning({ textBytes, downloadUrl, onShow }: LargeTextWarningProps) {
  return (
    <div style={{ padding: '.5in' }}>
      <div className="alert alert-warning alert-block">
        <h4>Large Text Warning</h4>
        <p>This document contains {formatBytes(textBytes)} of text</p>
      </div>
      <button type="button" className="btn btn-primary" onClick={onShow}>
        Display text
      </button>
      {downloadUrl && (
        <a href={downloadUrl} download className="btn btn-default" style={{ marginLeft: 4 }}>
          Download text
        </a>
      )}
    </div>
  );
}
